export function pageForDate(date) {
  var rDate = typeof date === 'string' ? new Date(date) : date;
  return {
    month: rDate.getMonth() + 1,
    year: rDate.getFullYear()
  };
}
export function isDayDisable(date, minDate) {
  if (!minDate) return false;
  if (!date) return false;
  var rDate = typeof date === 'string' ? new Date(date) : date;
  var rMinDate = typeof minDate === 'string' ? new Date(minDate) : minDate;
  var dateYear = rDate.getFullYear();
  var minDateYear = rMinDate.getFullYear();
  var dateMonth = rDate.getMonth() + 1;
  var minDateMonth = rMinDate.getMonth() + 1;
  var dateDay = rDate.getDate();
  var minDateDay = rMinDate.getDate();
  return dateYear < minDateYear || dateYear === minDateYear && dateMonth < minDateMonth || dateYear === minDateYear && dateMonth === minDateMonth && dateDay < minDateDay;
}
export function isMonthDisable(page, minDate) {
  if (!minDate) return false;
  if (!page || !page.year || !page.month) return false;
  var rMinDate = typeof minDate === 'string' ? new Date(minDate) : minDate;
  var minDateYear = rMinDate.getFullYear();
  var minDateMonth = rMinDate.getMonth() + 1;
  return page.year < minDateYear || page.year === minDateYear && page.month < minDateMonth;
}